function Error() {
  return (
      <div>Error 404, Page Not Found</div>
  );
}

export default Error;